<template>
  <div class="editor-container">
    <div v-el:toolbar id="toolbar" class="toolbar ql-toolbar ql-snow">
      <div class="ql-format-group">
        <select class="ql-size">
          <option value="10px">Small</option>
          <option value="13px" selected>Normal</option>
          <option value="18px">Large</option>
          <option value="32px">Huge</option>
        </select>
        <span class="ql-format-separator"></span>
        <a class="ql-format-button ql-bold"></a>
        <span class="ql-format-separator"></span>
        <a class="ql-format-button ql-underline"></a>
        <span class="ql-format-separator"></span>
        <a class="ql-format-button ql-italic"></a>
      </div>
      <div class="ql-format-group">
        <select title="Text Color" class="ql-color">
          <option value="rgb(0, 0, 0)" label="rgb(0, 0, 0)" selected=""></option>
          <option value="rgb(230, 0, 0)" label="rgb(230, 0, 0)"></option>
          <option value="rgb(255, 153, 0)" label="rgb(255, 153, 0)"></option>
          <option value="rgb(255, 255, 0)" label="rgb(255, 255, 0)"></option>
          <option value="rgb(0, 138, 0)" label="rgb(0, 138, 0)"></option>
          <option value="rgb(0, 102, 204)" label="rgb(0, 102, 204)"></option>
          <option value="rgb(153, 51, 255)" label="rgb(153, 51, 255)"></option>
          <option value="rgb(255, 255, 255)" label="rgb(255, 255, 255)"></option>
          <option value="rgb(230, 0, 18)" label="rgb(230, 0, 18)"></option>
          <option value="rgb(255, 235, 204)" label="rgb(255, 235, 204)"></option>
          <option value="rgb(255, 255, 204)" label="rgb(255, 255, 204)"></option>
          <option value="rgb(204, 232, 204)" label="rgb(204, 232, 204)"></option>
          <option value="rgb(204, 224, 245)" label="rgb(204, 224, 245)"></option>
          <option value="rgb(235, 214, 255)" label="rgb(235, 214, 255)"></option>
          <option value="rgb(187, 187, 187)" label="rgb(187, 187, 187)"></option>
          <option value="rgb(240, 102, 102)" label="rgb(240, 102, 102)"></option>
          <option value="rgb(255, 194, 102)" label="rgb(255, 194, 102)"></option>
          <option value="rgb(255, 255, 102)" label="rgb(255, 255, 102)"></option>
          <option value="rgb(102, 185, 102)" label="rgb(102, 185, 102)"></option>
          <option value="rgb(102, 163, 224)" label="rgb(102, 163, 224)"></option>
          <option value="rgb(194, 133, 255)" label="rgb(194, 133, 255)"></option>
          <option value="rgb(136, 136, 136)" label="rgb(136, 136, 136)"></option>
          <option value="rgb(161, 0, 0)" label="rgb(161, 0, 0)"></option>
          <option value="rgb(178, 107, 0)" label="rgb(178, 107, 0)"></option>
          <option value="rgb(178, 178, 0)" label="rgb(178, 178, 0)"></option>
          <option value="rgb(0, 97, 0)" label="rgb(0, 97, 0)"></option>
          <option value="rgb(0, 71, 178)" label="rgb(0, 71, 178)"></option>
          <option value="rgb(107, 36, 178)" label="rgb(107, 36, 178)"></option>
          <option value="rgb(68, 68, 68)" label="rgb(68, 68, 68)"></option>
          <option value="rgb(92, 0, 0)" label="rgb(92, 0, 0)"></option>
          <option value="rgb(102, 61, 0)" label="rgb(102, 61, 0)"></option>
          <option value="rgb(102, 102, 0)" label="rgb(102, 102, 0)"></option>
          <option value="rgb(0, 55, 0)" label="rgb(0, 55, 0)"></option>
          <option value="rgb(0, 41, 102)" label="rgb(0, 41, 102)"></option>
          <option value="rgb(61, 20, 102)" label="rgb(61, 20, 102)"></option>
        </select>
        <select title="Background Color" class="ql-background">
          <option value="rgb(0, 0, 0)" label="rgb(0, 0, 0)"></option>
          <option value="rgb(230, 0, 0)" label="rgb(230, 0, 0)"></option>
          <option value="rgb(255, 153, 0)" label="rgb(255, 153, 0)"></option>
          <option value="rgb(255, 255, 0)" label="rgb(255, 255, 0)"></option>
          <option value="rgb(0, 138, 0)" label="rgb(0, 138, 0)"></option>
          <option value="rgb(0, 102, 204)" label="rgb(0, 102, 204)"></option>
          <option value="rgb(153, 51, 255)" label="rgb(153, 51, 255)"></option>
          <option value="rgb(255, 255, 255)" label="rgb(255, 255, 255)" selected=""></option>
          <option value="rgb(230, 0, 18)" label="rgb(230, 0, 18)"></option>
          <option value="rgb(255, 235, 204)" label="rgb(255, 235, 204)"></option>
          <option value="rgb(255, 255, 204)" label="rgb(255, 255, 204)"></option>
          <option value="rgb(204, 232, 204)" label="rgb(204, 232, 204)"></option>
          <option value="rgb(204, 224, 245)" label="rgb(204, 224, 245)"></option>
          <option value="rgb(235, 214, 255)" label="rgb(235, 214, 255)"></option>
          <option value="rgb(187, 187, 187)" label="rgb(187, 187, 187)"></option>
          <option value="rgb(240, 102, 102)" label="rgb(240, 102, 102)"></option>
          <option value="rgb(255, 194, 102)" label="rgb(255, 194, 102)"></option>
          <option value="rgb(255, 255, 102)" label="rgb(255, 255, 102)"></option>
          <option value="rgb(102, 185, 102)" label="rgb(102, 185, 102)"></option>
          <option value="rgb(102, 163, 224)" label="rgb(102, 163, 224)"></option>
          <option value="rgb(194, 133, 255)" label="rgb(194, 133, 255)"></option>
          <option value="rgb(136, 136, 136)" label="rgb(136, 136, 136)"></option>
          <option value="rgb(161, 0, 0)" label="rgb(161, 0, 0)"></option>
          <option value="rgb(178, 107, 0)" label="rgb(178, 107, 0)"></option>
          <option value="rgb(178, 178, 0)" label="rgb(178, 178, 0)"></option>
          <option value="rgb(0, 97, 0)" label="rgb(0, 97, 0)"></option>
          <option value="rgb(0, 71, 178)" label="rgb(0, 71, 178)"></option>
          <option value="rgb(107, 36, 178)" label="rgb(107, 36, 178)"></option>
          <option value="rgb(68, 68, 68)" label="rgb(68, 68, 68)"></option>
          <option value="rgb(92, 0, 0)" label="rgb(92, 0, 0)"></option>
          <option value="rgb(102, 61, 0)" label="rgb(102, 61, 0)"></option>
          <option value="rgb(102, 102, 0)" label="rgb(102, 102, 0)"></option>
          <option value="rgb(0, 55, 0)" label="rgb(0, 55, 0)"></option>
          <option value="rgb(0, 41, 102)" label="rgb(0, 41, 102)"></option>
          <option value="rgb(61, 20, 102)" label="rgb(61, 20, 102)"></option>
        </select>
      </div>
      <div class="ql-format-group">
        <span title="List" class="ql-format-button ql-list"></span>
        <span class="ql-format-separator"></span>
        <span title="Bullet" class="ql-format-button ql-bullet"></span>
        <span class="ql-format-separator"></span>
        <select title="Text Alignment" class="ql-align">
          <option value="left" label="Left" selected=""></option>
          <option value="center" label="Center"></option>
          <option value="right" label="Right"></option>
          <option value="justify" label="Justify"></option>
        </select>
      </div>
      <div class="ql-format-group">
        <span class="ql-format-separator"></span>
        <span title="Link" class="ql-format-button ql-link"></span>
        <span title="Link" class="ql-format-button ql-link" @click.prevent="toggleBlank"></span>
      </div>
      <div class="ql-format-group">
        <!-- <span title="Image" class="ql-format-button ql-image"></span> -->
        <d-upload  @callback="insert" @mouseOver="saveIndex()" class="ql-format-button ql-image"></d-upload>
      </div>
    </div>
    <div v-el:editor id="editor" class="editor ql-container ql-snow">
    </div>
  </div>
</template>

<script>
import '!style!css!quill/dist/quill.base.css'
import '!style!css!quill/dist/quill.snow.css'

import DUpload from './Upload'
import Quill from 'quill'

export default {
  props: {
    content: {
      coerce (val) {
        return val || ''
      }
    }
  },
  components: {
    DUpload
  },
  data () {
    return {
      editor: {},
      range: null
    }
  },
  ready () {
    /* eslint-disable no-new */
    this.editor = new Quill(this.$els.editor, {
      modules: {
        toolbar: this.$els.toolbar,
        'link-tooltip': true
      },
      theme: 'snow'
    })
    this.editor.setHTML(this.content)
    window.editor = this.editor

    this.editor.on('text-change', (delta, source) => {
      this.content = this.editor.getHTML()
    })
  },
  methods: {
    saveIndex () {
      this.range = this.editor.getSelection()
    },
    toggleBlank () {
      let node = window.getSelection().focusNode
      if (!node || !node.parentElement || node.parentElement.tagName !== 'A') {
        return
      }
      let link = node.parentElement
      let target = link.getAttribute('target') || ''
      if (target.toLowerCase() !== '_blank') {
        link.setAttribute('target', '_blank')
      } else {
        link.removeAttribute('target')
      }
      this.content = this.editor.getHTML()
    },
    insert (url) {
      let index
      if (this.range) {
        index = this.range.end
      } else {
        index = this.editor.getLength()
      }
      setTimeout(() => {
        this.editor.insertEmbed(index, 'image', url)
      })
    }
  },
  watch: {
    content (val, oldVal) {
      if (val !== this.editor.getHTML()) {
        this.editor.setHTML(val)
      }
    }
  }
}
</script>

<style>
  #toolbar {
    border-bottom: 1px solid #ccc;
  }
  .editor-container {
    border: 1px solid #ccc;
  }
  .ql-editor {
    min-height: 200px !important;
  }
  .ql-image {
    border: none;
    background-color: transparent;
    outline: none;
  }
  #editor a[target=_blank] {
    text-decoration: none;
    border-bottom: 1px dashed red;
  }
</style>



/** WEBPACK FOOTER **
 ** Editor.vue?72dc8b10
 **/